import { useQuery } from '@tanstack/react-query'
import { fetchOrdersByCustomerId } from '@/services/menuService'
import { getCustomerId } from '@/utils/customerIdentifier'
import { Order } from '@/types'

export function useCustomerOrders(branchId?: string) {
  const customerId = getCustomerId()
  return useQuery<Order[]>({
    queryKey: ['customer-orders', customerId, branchId],
    queryFn: () => fetchOrdersByCustomerId(customerId, branchId),
    enabled: !!customerId,
    staleTime: 5 * 60 * 1000,
  })
} 